import { INavPreviewCol } from "@models/nav.interface";

interface IResourcesPreviewState {
  columns: INavPreviewCol[];
}

export const ResourcesPreviewState: IResourcesPreviewState = {
  columns: [
    {
      cards: [
        {
          title: 'Resources.Nav.Developers.Title',
          subtitle: 'Resources.Nav.Developers.Subtitle',
          iconSrc: '/layout-images/header/resources-preview/user-settings.svg',
          href: 'https://gofinans.readme.io',
          newTab: true,
        },
        // {
        //   title: 'Resources.Nav.SupportedChains.Title',
        //   subtitle: 'Resources.Nav.SupportedChains.Subtitle',
        //   iconSrc: '/layout-images/header/resources-preview/user-headset.svg',
        //   href: '/',
        // },
        // {
        //   title: 'Resources.Nav.TalkToSales.Title',
        //   subtitle: 'Resources.Nav.TalkToSales.Subtitle',
        //   iconSrc: '/layout-images/header/resources-preview/chart-line-up-outline.svg',
        //   href: '/',
        // },
      ],
    },
  ],
};
